import { render, staticRenderFns } from "./closing-dialog.vue?vue&type=template&id=6d079bde&"
import script from "./closing-dialog.vue?vue&type=script&lang=js&"
export * from "./closing-dialog.vue?vue&type=script&lang=js&"
import style0 from "./closing-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports